/**
 * MAIN PLUG — the single InitiateCheckout surface for the whole store.
 *
 * WHY THIS IS ITS OWN FILE
 * ------------------------
 * Every route to checkout on this store ends at one button: the cart's
 * `.cart__checkout-button`. That is true in the drawer and on the /cart page,
 * and it is true because Phoenix (PHX) hooks that button BY CSS SELECTOR and
 * redirects to secureorder.stocksupply.co. Nothing here navigates; this file
 * only watches.
 *
 * Shopify's own `checkout_started` event never fires on this store, because PHX
 * takes the customer off-Shopify before Shopify emits it. So InitiateCheckout
 * has to be raised from the storefront, from exactly one place, or it either
 * never fires or fires twice.
 *
 * ONE LISTENER, ONE EVENT
 * -----------------------
 * - Installed once per page load, guarded by a flag on `window`, because the
 *   drawer's markup is re-rendered (morphed) on every cart change and any
 *   listener bound to the button itself would be re-bound or lost.
 * - Bound on `document` in the CAPTURE phase, so it runs before PHX's own
 *   handler and cannot be swallowed by stopPropagation().
 * - Fires at most once per page load: PHX navigates away immediately after, so
 *   a second click is the same intent, not a new one.
 *
 * The event id is a fresh UUID. PHX sends the same id server-side on its
 * conversion postback, which is what lets Meta collapse the browser and server
 * copies into a single event instead of counting both.
 */
(function () {
  if (window.__mpCheckoutTrackerInstalled) return;
  window.__mpCheckoutTrackerInstalled = true;

  var CHECKOUT_BUTTON = '.cart__checkout-button';
  var fired = false;

  function eventId() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'e-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function cartUrl() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'cart.js';
  }

  function publish(detail) {
    try {
      document.dispatchEvent(
        new CustomEvent('mainplug:begin_checkout', { detail: detail, bubbles: true })
      );
    } catch (e) {}

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'mainplug:begin_checkout' }, detail));
    }

    // A Shopify custom pixel runs in a sandboxed iframe and cannot see document
    // events from this page. analytics.publish is the only supported bridge into
    // it, and published event names may not contain a colon.
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('mainplug_begin_checkout', detail);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest(CHECKOUT_BUTTON)) return;
      if (fired) return;
      fired = true;

      // Read the cart rather than the DOM: the totals shown in the drawer are
      // formatted strings, and the real discounted value is what Meta needs.
      fetch(cartUrl(), { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          publish({
            eventId: eventId(),
            value: cart.total_price / 100,
            currency: cart.currency || 'USD',
            quantity: cart.item_count,
            cartToken: cart.token,
            items: (cart.items || []).map(function (item) {
              return {
                id: item.variant_id,
                productId: item.product_id,
                quantity: item.quantity,
                price: item.final_price / 100
              };
            })
          });
        })
        .catch(function () {
          // Losing the payload is better than blocking the hand-off to PHX.
        });
    },
    true
  );
})();
